// src/i18n/weatherVoice/en.js
//
// Weather Voice primary English natural adaptation of the is.js entries (same
// IDs, same order). Natural adaptations, not literal translations (Bible §8).
// Metadata is shared via weatherVoiceContent.js's registry, keyed by the same id.
export const en = [
  { id: "good_01", text: "This'll do." },
  { id: "good_02", text: "Well. This is just good." },
  { id: "good_03", text: "No complaints for now." },
  { id: "good_04", text: "I can't find anything wrong with this." },
  { id: "good_05", text: "The weather is behaving." },
  { id: "good_06", text: "It's been worse." },
  { id: "good_07", text: "I approve." },
  { id: "good_08", text: "No need for drama." },
  { id: "good_09", text: "This is strangely normal." },
  { id: "good_10", text: "I'm not ruining this with complaints." },
  { id: "good_11", text: "This passes inspection." },
  { id: "good_12", text: "Well. No valid complaints." },
  { id: "good_13", text: "Apparently I worried for nothing." },
  { id: "good_14", text: "The weather came prepared." },
  { id: "good_15", text: "I can work with this." },
  { id: "good_16", text: "Much better than this would be suspicious." },
  { id: "good_17", text: "I'll just quietly appreciate this." },
  { id: "good_18", text: "No trouble. Strange." },
  { id: "good_19", text: "This is almost responsible weather." },
  { id: "good_20", text: "Icelandic weather forgot itself for a moment." },
  { id: "good_21", text: "Fine. You win." },
  { id: "good_22", text: "I was ready to complain." },
  { id: "good_23", text: "This is actually quite nice." },
  { id: "excellent_01", text: "This is suspiciously good." },
  { id: "excellent_03", text: "All that's missing is the coffee." },
  { id: "excellent_04", text: "This is outdoor weather." },
  { id: "excellent_05", text: "Well. This is uncomfortably good." },
  { id: "excellent_06", text: "I wasn't prepared for this." },
  { id: "excellent_07", text: "Something must be wrong." },
  { id: "excellent_08", text: "This almost requires photographic evidence." },
  { id: "excellent_09", text: "I have... nothing to complain about." },
  { id: "excellent_10", text: "Apparently this happens." },
  { id: "excellent_11", text: "I'm leaving this one alone." },
  { id: "excellent_12", text: "Well, look at that." },
  { id: "excellent_13", text: "This is almost excessive." },
  { id: "excellent_14", text: "The weather is showing off." },
  { id: "excellent_15", text: "I'm not entirely comfortable with this." },
  { id: "excellent_16", text: "Who ordered this?" },
  { id: "excellent_17", text: "This isn't very Icelandic." },
  { id: "excellent_18", text: "I checked twice." },
  { id: "excellent_19", text: "This is good. Suspiciously good." },
  { id: "excellent_20", text: "I'm speechless. Almost." },
  { id: "excellent_21", text: "Fine. This is excellent." },
  { id: "excellent_22", text: "I'm not asking questions." },
  { id: "excellent_23", text: "Apparently this is how it's done." },
  { id: "rain_01", text: "Comes with water." },
  { id: "rain_02", text: "Rain jacket, starring role." },
  { id: "rain_03", text: "Water. From above." },
  { id: "rain_04", text: "Yes, yes. Rain." },
  { id: "rain_05", text: "Of course." },
  { id: "rain_06", text: "Dry has the day off." },
  { id: "rain_07", text: "The sky is leaking." },
  { id: "rain_08", text: "Apparently this needed to be wet." },
  { id: "rain_09", text: "The weather chose water." },
  { id: "rain_10", text: "The rain arrived right on time. As always." },
  { id: "rain_11", text: "Dry clearly wasn't on the agenda." },
  { id: "rain_12", text: "Waterproof is a beautiful word." },
  { id: "rain_13", text: "Very Icelandic." },
  { id: "rain_14", text: "The rain is here. Apparently it was missed." },
  { id: "rain_15", text: "Everything is slightly wetter now." },
  { id: "rain_16", text: "The sky is on wash cycle." },
  { id: "rain_17", text: "Rain has taken the shift." },
  { id: "rain_18", text: "Apparently something needed watering." },
  { id: "rain_19", text: "The weather took the wet route." },
  { id: "rain_20", text: "Dry would have been too simple." },
  { id: "rain_21", text: "Rain. Classic." },
  { id: "rain_22", text: "The clouds clearly have a job to do." },
  { id: "rain_23", text: "Apparently it's good for the plants." },
  { id: "cold_01", text: "The sweater was right." },
  { id: "cold_03", text: "The coffee cools out of sympathy." },
  { id: "cold_04", text: "It's just refreshing." },
  { id: "cold_05", text: "Apparently there's no such thing as cold." },
  { id: "cold_06", text: "Apparently it's all about the clothing." },
  { id: "cold_07", text: "The temperature has modest ambitions." },
  { id: "cold_08", text: "Apparently this counts as fresh." },
  { id: "cold_09", text: "The thermometer isn't feeling ambitious." },
  { id: "cold_10", text: "The shorts get the day off." },
  { id: "cold_11", text: "Sweater weather." },
  { id: "cold_12", text: "The warmth didn't show up." },
  { id: "cold_13", text: "At least it's not too warm." },
  { id: "cold_14", text: "The warmth went somewhere else." },
  { id: "cold_15", text: "Well. Wool." },
  { id: "cold_16", text: "Fresh. Very fresh." },
  { id: "cold_17", text: "That's one way to wake up." },
  { id: "cold_18", text: "Warm is a relative term." },
  { id: "cold_19", text: "The thermometer is holding back." },
  { id: "cold_20", text: "Not exactly a heatwave." },
  { id: "cold_21", text: "The warmth is keeping a low profile." },
  { id: "cold_22", text: "The cold showed up." },
  { id: "cold_23", text: "A few degrees appear to be missing." },
  { id: "cold_24", text: "There's no bad cold, only bad clothing." },
  { id: "sun_wind_01", text: "The sun showed up. The calm didn't." },
  { id: "sun_wind_02", text: "Bright skies. Hair sideways." },
  { id: "sun_wind_03", text: "The sun came. So did the wind." },
  { id: "sun_wind_04", text: "Bright and breezy." },
  { id: "sun_wind_05", text: "The sun is doing its thing. So is the wind." },
  { id: "sun_wind_06", text: "Beautiful. With a headwind." },
  { id: "sun_wind_07", text: "The sun looks promising. The wind has other ideas." },
  { id: "sun_wind_08", text: "Bright skies. Calm, less so." },
  { id: "sun_wind_09", text: "The sun is innocent in all this." },
  { id: "sun_wind_10", text: "The wind won't let the sun have the stage." },
  { id: "sun_wind_11", text: "Sunshine with sound effects." },
  { id: "sun_wind_12", text: "Bright. Not exactly still." },
  { id: "sun_wind_13", text: "The sun didn't come alone." },
  { id: "sun_wind_14", text: "Looks lovely from a distance." },
  { id: "sun_wind_15", text: "Sun and wind. A classic partnership." },
  { id: "sun_wind_16", text: "The weather couldn't just be nice." },
  { id: "sun_wind_17", text: "The sun is trying." },
  { id: "sun_wind_18", text: "Clear skies, with conditions attached." },
  { id: "sun_wind_19", text: "Sunshine. With some resistance." },
  { id: "sun_wind_20", text: "The wind wants attention too." },
  { id: "sun_wind_21", text: "Sun above. Wind from the side." },
  { id: "sun_wind_22", text: "Almost perfect." },
];
